module.exports = __webpack_public_path__ + "img/1-4.f10e6da5.svg";